import { merge } from "lodash";

import common from "./common";
import v2 from "./v2";

export default {
  leads: {
    leadList: {
      title: "Leads",
      tabs: {
        emails: "Emails",
        archive: "Archive",
        spam: "Spam",
      },
      deprecationMessage: {
        title: "Please note:",
        content:
          "This page is going to shutdown on <strong>1 February 2024</strong> and will be replaced with the new lead management system, please backup all your old leads before the end date if necessary.",
      },
      button: {
        back: "Back",
        backToLeadManagement: "Back to Lead Management",
      },
    },
    leadDetail: {
      button: {
        back: "Back",
        email: "Email",
        call: "Call",
      },
      listingTitle: "Listing",
      listingTitleChannel: {
        sale: " For Sale",
        rent: " For Rent",
        both: " For Both",
      },
      action: {
        label:
          "{selectedListingCount} enquir{selectedListingCount, plural, =0 {y} =1 {y} other{ies}} selected",
      },
    },
    ...merge(common, v2, {}),
  },
};
